<template>
  <div id="channelFollowList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <cander v-model="searchData.beginTime" :className="'allInput'" placeholderName="开始时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="searchData.endTime" :minDate="searchData.beginTime" :className="'allInput'" placeholderName="结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <allSelectTwo :chooseData="disabList" :needReturn="'id'" v-on:on-change="selDis($event)" :placeholder="'是否禁用'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.IsDisabled" :borderLine="'#e1e1e1'">
            </allSelectTwo>
          </p>
          <button class="redButton" @click="getFollowList(1)">搜索</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <nav class="m_b_10"><button class="redButtonTwo" @click="exportList">导出</button></nav>
        <table cellspacing="0" class="allTable">
          <thead>
            <tr>
              <th class="t_c">渠道名</th>
              <th class="t_c">是否禁用</th>
              <th class="t_c">关注量</th>
              <th class="t_c">留存量</th>
              <th class="t_c">注册量</th>
              <th class="t_c">注册占比</th>
              <th class="t_c">累计关注量</th>
              <th class="t_c">累计留存量</th>
              <th class="t_c">累计注册量</th>
              <th class="t_c">累计注册占比</th>
              <th class="t_c">操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="followList.length >0">
              <tr :key="index" v-for="(item, index) in followList">
                <td width="10%" class="t_c NoWrap" :title="item.channelName">{{item.channelName}}</td>
                <td>{{item.isDisabled}}</td>
                <td width="10%" class="t_c colorBlue" @click="toFollowDetail(item)" :title="item.followNum" style="cursor: pointer;text-decoration:underline #408DEB;min-width:100px;">
                  {{item.followNum}}
                </td>
                <td width="10%" class="t_c" :title="item.existNum">{{item.existNum}}</td>
                <td width="10%" class="t_c colorBlue" @click="toRegisterDetail(item)" :title="item.registerNum" style="cursor: pointer;text-decoration:underline #408DEB;min-width:100px;">
                  {{item.registerNum}}
                </td>
                <td width="10%" class="t_c" :title="item.registerProportionStr">{{item.registerProportionStr}}</td>
                <td width="10%" class="t_c" :title="item.followSum">{{item.followSum}}</td>
                <td width="10%" class="t_c" :title="item.existSum">{{item.existSum}}</td>
                <td width="10%" class="t_c" :title="item.registerSum">{{item.registerSum}}</td>
                <td width="10%" class="t_c" :title="item.registerProportionSumStr">{{item.registerProportionSumStr}}</td>
                <td width="10%" class="t_c colorBlue" @click="exportMonthDetail(item)" style="cursor: pointer;text-decoration:underline #408DEB;min-width:100px;">
                  月份统计
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="10">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getFollowList($event)" :totalPage="totalPage" :page="searchData.PageIndex" :explain="0"></page>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
let time
export default {
  name: 'channelFollowList',
  data () {
    return {
      searchData: {
        IsDisabled: '',
        beginTime: this.$commonJs.firstDate,
        endTime: this.$commonJs.todayDate,
        PageIndex: 1,
        pageSize: 10
      },
      followList: [],
      totalPage: 0,
      totalCount: 0,
      disabList: [
        {
          id: '',
          name: '全部'
        },
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ]
    }
  },
  activated () {
    time = setTimeout(p => {
      if (localStorage.isDis) {
        this.searchData.IsDisabled = ''
        this.getFollowList(1)
        localStorage.removeItem('isDis')
      }
    }, 100)
  },
  created () {
    // 获取列表数据
    this.getFollowList(1)
  },
  mounted () {
  },
  destroyed () {
    clearTimeout(time)
  },
  methods: {
    selDis () {
      localStorage.removeItem('isDis')
    },
    // 获取列表数据
    getFollowList (page) {
      this.searchData.PageIndex = page
      let params = {
        pageIndex: this.searchData.PageIndex,
        pageSize: this.searchData.pageSize
      }
      let beginTime = this.searchData.beginTime
      let endTime = this.searchData.endTime ? this.searchData.endTime + ' 23:59:59' : ''

      this.$axiox.post(`/api/ChannelQRCode/QueryReport?beginTime=${beginTime}&endTime=${encodeURIComponent(endTime)}&IsDisabled=${this.searchData.IsDisabled}`, params).then(res => {
        console.log(res, 'getFollowList')
        if (res.data && res.data.length > 0) {
          this.followList = res.data
          this.totalPage = Math.ceil(res.total / this.searchData.pageSize)
          this.totalCount = res.total
        } else {
          this.followList = []
          this.totalPage = 0
          this.totalCount = 0
        }
      })
    },
    exportList () {
      let beginTime = this.searchData.beginTime
      let endTime = this.searchData.endTime ? this.searchData.endTime + ' 23:59:59' : ''
      axios.get(`/api/ChannelQRCode/Export?beginTime=${beginTime}&endTime=${encodeURIComponent(endTime)}&IsDisabled=${this.searchData.IsDisabled}`, {responseType: "arraybuffer"}).then(res => {
        console.log(res, 'exportList')
        const data = res.data
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '统计报表.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })
    },
    // 关注详情
    toFollowDetail (item) {
      this.$router.push({
        path: '/followDetailList',
        query: {
          channelID: item.id,
          startTime: this.searchData.beginTime,
          endTime: this.searchData.endTime,
          channelName: item.channelName,
          categoryName: item.categoryName
        }
      })
    },
    // 注册详情
    toRegisterDetail (item) {
      this.$router.push({
        path: '/registerDetailList',
        query: {
          channelID: item.id,
          startTime: this.searchData.beginTime,
          endTime: this.searchData.endTime,
          channelName: item.channelName,
          categoryName: item.categoryName
        }
      })
    },
    exportMonthDetail (item) {
      axios.get(`/api/ChannelQRCode/ExportMonthDetail?channelID=${item.id}`, {responseType: "arraybuffer"}).then(res => {
        console.log(res, 'exportList')
        const data = res.data
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', item.channelName + '-月份统计.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/qrCodeManager/channelFollowList.vue